/* eslint-disable no-template-curly-in-string */
const cloudName = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;

const one =`https://res.cloudinary.com/${cloudName}/image/upload/casascampos/home-one_nehflh_qqudyx.webp`;
const two = `https://res.cloudinary.com/${cloudName}/image/upload/casascampos/home-two_uqtz30_vzk5xj.webp`;
const three = `https://res.cloudinary.com/${cloudName}/image/upload/casascampos/home-three.webp`;
const four = `https://res.cloudinary.com/${cloudName}/image/upload/casascampos/home-four_otjpic_pewpn7.webp`;
const five = `https://res.cloudinary.com/${cloudName}/image/upload/casascampos/home-five_dzdim0.webp`;

const img2 = `https://res.cloudinary.com/${cloudName}/image/upload/casascampos/4prop_b4ovqm.webp`;
const img3 = `https://res.cloudinary.com/${cloudName}/image/upload/casascampos/2prop_tvrkth_fqd1wo.webp`;
const img4 = `https://res.cloudinary.com/${cloudName}/image/upload/casascampos/3prop_fh8jje.webp`;
const img10 = `https://res.cloudinary.com/${cloudName}/image/uploadcasascampos/10prop_h7bzwh_tjvmf4.webp`;
const img11 = `https://res.cloudinary.com/${cloudName}/image/upload/casascampos/11prop_nft8b3.webp`;
const img13 = `https://res.cloudinary.com/${cloudName}/image/upload/casascampos/13prop_czyugq_lbojbi.webp`;
const img19 = `https://res.cloudinary.com/${cloudName}/image/upload/casascampos/19prop_iyd3tv_wvkt15.webp`;

const azeitao = `https://res.cloudinary.com/${cloudName}/image/upload/casascampos/1_es7zzu.webp`;
const comporta = `https://res.cloudinary.com/${cloudName}/image/upload/casascampos/2_lul8r7.webp`;
const sintra = `https://res.cloudinary.com/${cloudName}/image/upload/casascampos/3_mowbc8.webp`;
const sesimbra = `https://res.cloudinary.com/${cloudName}/image/upload/casascampos/4_ijq9au.webp`;
const estoril = `https://res.cloudinary.com/${cloudName}/image/upload/casascampos/5_kxhofq.webp`;
const troia = `https://res.cloudinary.com/${cloudName}/image/upload/casascampos/6_obzlcc.webp`;

const blueprop = `https://res.cloudinary.com/${cloudName}/image/upload/casascampos/blue_defxta.webp`;

const about = `https://res.cloudinary.com/${cloudName}/image/upload/casascampos/about_i1lcjb_nczvgn.webp`;
const algarve = `https://res.cloudinary.com/${cloudName}/image/upload/casascampos/a1_e3f2et_unmiaw.webp`;
const centro = `https://res.cloudinary.com/${cloudName}/image/upload/casascampos/a2_rizaw4_eebreg.webp`;
const douro = `https://res.cloudinary.com/${cloudName}/image/upload/casascampos/a3_ecqtzy_kxy3b3.webp`;
const card1 = `https://res.cloudinary.com/${cloudName}/image/upload/casascampos/13prop_czyugq_lbojbi.webp`;
const card2 = `https://res.cloudinary.com/${cloudName}/image/upload/casascampos/card4_nyqljt_c5voc9.webp`;
const card3 = `https://res.cloudinary.com/${cloudName}/image/upload/casascampos/card_house_one_bqjz4v.webp`;
const card4 = `https://res.cloudinary.com/${cloudName}/image/upload/casascampos/card_house_four_b6gcn0.webp`;
const p1 = `https://res.cloudinary.com/${cloudName}/image/upload/casascampos/Rectangle_35_zsad1a_h8pmoc.webp`;
const p2 = `https://res.cloudinary.com/${cloudName}/image/upload/casascampos/Rectangle_36_x8pjvv_fr8auj.webp`;
const p3 = `https://res.cloudinary.com/${cloudName}/image/upload/casascampos/Rectangle_37_lbjj8r_nvpckp.webp`;
const p4 = `https://res.cloudinary.com/${cloudName}/image/upload/casascampos/Rectangle_38_d24rtv_yl5kw8.webp`;
const p5 = `https://res.cloudinary.com/${cloudName}/image/upload/casascampos/Rectangle_39_rc0d7a_t2xxm5.webp`;
const p6 = `https://res.cloudinary.com/${cloudName}/image/upload/casascampos/Rectangle_40_dr1byx_ww08tf.webp`;
const quote = `https://res.cloudinary.com/${cloudName}/image/upload/casascampos/quote_gkgigp.svg`;
const h1 = `https://res.cloudinary.com/${cloudName}/image/upload/casascampos/h1_cuybxt.webp`;
const h2 = `https://res.cloudinary.com/${cloudName}/image/upload/casascampos/h2_bccvpv.webp`;
const h3 = `https://res.cloudinary.com/${cloudName}/image/upload/casascampos/h3_fpoxoy_jygdft.webp`;
const h4 = `https://res.cloudinary.com/${cloudName}/image/upload/casascampos/h4_oxpbif.webp`;
const h5 = `https://res.cloudinary.com/${cloudName}/image/upload/casascampos/h5_blqhez_demavf.webp`;
const phone = `https://res.cloudinary.com/${cloudName}/image/upload/casascampos/phone_icmsnd_wnht05.webp`;
const card10 = `https://res.cloudinary.com/${cloudName}/image/upload/casascampos/card0_o1mk92_hlvmmk.webp`;
const card11 = `https://res.cloudinary.com/${cloudName}/image/upload/casascampos/card01_adr9pj_puntqk.webp`;
const card21 = `https://res.cloudinary.com/${cloudName}/image/upload/casascampos/card2_to6igi_qypbek.webp`;
const card31 = `https://res.cloudinary.com/${cloudName}/image/upload/casascampos/card3_myatv7_abdrwt.webp`;
const owner = `https://res.cloudinary.com/${cloudName}/image/upload/casascampos/banner.webp`;
const card01 = `https://res.cloudinary.com/${cloudName}/image/upload/casascampos/card01_adr9pj.webp`;
const card02 = `https://res.cloudinary.com/${cloudName}/image/upload/casascampos/card02_rth2ky_fupi8v.webp`;
const card03 = `https://res.cloudinary.com/${cloudName}/image/upload/casascampos/card03_ld0wik_nqtfge.webp`;
const card04 = `https://res.cloudinary.com/${cloudName}/image/upload/casascampos/card04_nuen9w_dzreiz.webp`;
const logo = `https://res.cloudinary.com/${cloudName}/image/upload/logo_nm2un4.svg`;
const globe = `https://res.cloudinary.com/${cloudName}/image/upload/globe-solid_vch2r8.svg`;
const hamburger = `https://res.cloudinary.com/${cloudName}/image/upload/bars-solid_vgfbs0.svg`;
const xmark = `https://res.cloudinary.com/${cloudName}/image/upload/xmark-solid_wrfbt5.svg`;

export { hamburger,
  xmark,
  globe,
    logo,
    one, 
    two, 
    three, 
    four, 
    five, 
    img2, 
    img3, 
    img4, 
    img10, 
    img11,     
    img13,    
    img19,    
    comporta,    
    azeitao,    
    sintra,    
    sesimbra,    
    estoril,    
    troia,    
    blueprop,   
    about,
    algarve,
    centro,
    douro,
    card1,
    card2,
    card3,
    card4,
    p1,
    p2,
    p3,
    p4,
    p5,
    p6,
    quote,
    h1,
    h2,
    h3,
    h4,
    h5,
    phone,
    card10,
    card11,
    card21,
    card31,
    owner,
    card01,
    card02,
    card03,
    card04,
  };
